import { format } from 'date-fns-tz';

const getGmtOffsetForTimezone = timeZone => {
  if (timeZone === 'Etc/UTC') {
    return '+00:00';
  }

  // Current date and time
  const now = new Date();

  // Format date to get GMT offset, e.g., `GMT+0200` (CEST)
  // `xxx` token is used to get the offset in hours and minutes (e.g., +02:00)
  const offset = format(now, 'xxx', { timeZone });

  return offset;
};

export default getGmtOffsetForTimezone;
